import React, { Component } from "react";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IOnProcessMaterialDTO from "../../../models/DTO/IOnProcessMaterialDTO";
import IProcessMaterialDTO from "../../../models/DTO/IProcessMaterialDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IMaterial from "../../../models/IMaterial";
import INotification from "../../../models/INotification";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import OwButton from "../../shared/OwButton/OwButton";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";
import { Socket } from "socket.io-client";

type Props = {
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    socket: Socket;
    toggleSidebar: (shouldBeVisible?: boolean) => void;
    material?: IMaterial;
};

type State = {
    name: string;
    qty_on_hand: number;
};

class MaterialSidebar extends Component<Props, State> {
    readonly state: State = {
        name: this.props.material?.name || "",
        qty_on_hand: this.props.material?.qty_on_hand || 0,
    };

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.MaterialOnProcessMaterial, this.onProcessMaterial);
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.MaterialOnProcessMaterial, this.onProcessMaterial);
    }

    cancel = () => {
        this.props.toggleSidebar(false);
    };

    handleChange = (e: any) => {
        const value = e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    processMaterial = () => {
        const payload: IProcessMaterialDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            material: {
                name: this.state.name,
                qty_on_hand: this.state.qty_on_hand,
            },
        };

        if (this.props.material) {
            payload.material.guid = this.props.material.guid;
        }

        this.props.socket.emit(EndpointsEnum.MaterialProcessMaterial, payload);
    };

    onProcessMaterial = (data: IOnProcessMaterialDTO) => {
        const notification: INotification = {
            title: "successfully_processed_material",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.br,
        };

        this.props.notifyFn(null, notification);

        this.props.toggleSidebar(false);
    };

    render() {
        let header = "create_material";

        if (this.props.material) {
            header = "update_material";
        }

        return (
            <div className="MaterialSidebar d-flex flex-column mh-100">
                <div className={"p-3"}>
                    <div className="text-end">
                        <OwButton centerIconClass={"far fa-times"} className={"btn-danger"} fn={this.cancel} />
                    </div>
                    <OwTitle className={"mb-2"} leftIconName={"fad fa-cubes"} title={header} />
                    <hr />
                </div>

                <div className={"p-3"} style={{ height: "auto", overflowY: "scroll" }}>
                    <div>
                        <div>
                            <OwLabel title={"name"} />
                            <OwInputWrapper name={"name"} fn={this.handleChange} value={this.state.name} />
                        </div>
                        <div>
                            <OwLabel title={"qty_on_hand"} />
                            <OwInputWrapper name={"qty_on_hand"} fn={this.handleChange} value={this.state.qty_on_hand} type={"number"} />
                        </div>
                    </div>
                    <div className={"mt-2"}>
                        <OwButton title={"save"} className={"btn-success"} fn={this.processMaterial} />
                    </div>
                </div>
            </div>
        );
    }
}

export default MaterialSidebar;
